import React from 'react'

const Footer = () => {
  return (
    <div className="bg-black text-center text-white">Footer</div>
  )
}

export default Footer